/**
 * Google Sign-In authorized origin is a single host (apex). District apps run on subdomains.
 * OAuth pages must load on this origin; we then hand off the JWT to the subdomain via /auth/import.
 */

export const APEX_ROOT = 'backtoschoolforms.com';

export function getPublicAuthOrigin() {
  const fromEnv = process.env.REACT_APP_PUBLIC_AUTH_ORIGIN;
  if (fromEnv && String(fromEnv).trim()) {
    return String(fromEnv).trim().replace(/\/$/, '');
  }
  if (typeof window !== 'undefined') {
    const h = window.location.hostname;
    if (h === 'localhost' || h === '127.0.0.1') {
      return `${window.location.protocol}//${window.location.host}`;
    }
  }
  return `https://${APEX_ROOT}`;
}

/** True when we use apex OAuth + subdomain handoff (disabled on localhost). */
export function isProductionMultiHostAuth() {
  if (typeof window === 'undefined') return false;
  const h = window.location.hostname;
  return h !== 'localhost' && h !== '127.0.0.1';
}

export function isOAuthAuthHost() {
  if (typeof window === 'undefined') return true;
  const cur = `${window.location.protocol}//${window.location.host}`;
  return cur === getPublicAuthOrigin();
}

export function isDistrictSubdomainHost(hostname) {
  const h = (hostname || (typeof window !== 'undefined' ? window.location.hostname : '')).toLowerCase();
  if (!h || h === 'localhost' || h === '127.0.0.1') return false;
  if (h === APEX_ROOT || h === `www.${APEX_ROOT}`) return false;
  if (h === `smadmin.${APEX_ROOT}`) return false;
  return h.endsWith(`.${APEX_ROOT}`);
}

/**
 * Any hostname under the apex except the bare apex (e.g. smart., www., smadmin.).
 */
export function isUnderApexMultihost(hostname) {
  const h = (hostname || (typeof window !== 'undefined' ? window.location.hostname : '')).toLowerCase();
  if (!h || h === 'localhost' || h === '127.0.0.1') return false;
  if (h === APEX_ROOT) return false;
  return h.endsWith(`.${APEX_ROOT}`);
}

/**
 * Subdomain slug for district sites, from hostname or ?subdomain=
 */
export function detectSchoolSubdomainFromLocation(searchParams) {
  if (typeof window === 'undefined') return '';
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  const querySubdomain = searchParams && typeof searchParams.get === 'function'
    ? searchParams.get('subdomain') || ''
    : '';

  if (hostname.includes('localhost')) {
    return querySubdomain;
  }
  if (parts.length >= 4 && parts[0] !== 'www' && parts[0] !== 'smadmin') {
    return parts[0];
  }
  if (querySubdomain) {
    return querySubdomain;
  }
  if (parts.length >= 3 && parts[0] !== 'www' && parts[0] !== 'smadmin') {
    return parts[0];
  }
  return '';
}
